<script setup lang="ts">
import { NumberFieldDecrement, NumberFieldIncrement, NumberFieldInput, NumberFieldRoot } from "reka-ui";

defineProps<{ max?: number }>();
const modelValue = defineModel<number>();
</script>

<template>
  <NumberFieldRoot v-model="modelValue" class="inline-flex items-center gap-2" :min="1" :max="max">
    <NumberFieldDecrement class="btn-input-quantity shrink-0">
      <span class="i-lucide-minus" />
    </NumberFieldDecrement>
    <NumberFieldInput class="max-w-16 text-center tabular-nums" />
    <NumberFieldIncrement class="btn-input-quantity shrink-0">
      <span class="i-lucide-plus" />
    </NumberFieldIncrement>
  </NumberFieldRoot>
</template>
